module.exports = __webpack_public_path__ + "img/map-pointer.84185ac.svg";